/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SetLifetimeMembersDto interface.
 */
export function instanceOfSetLifetimeMembersDto(value) {
    if (!('emails' in value) || value['emails'] === undefined)
        return false;
    if ((!('lifetimeMember' in value) && !('lifetime_member' in value)) || (value['lifetimeMember'] === undefined && value['lifetime_member'] === undefined))
        return false;
    return true;
}
export function SetLifetimeMembersDtoFromJSON(json) {
    return SetLifetimeMembersDtoFromJSONTyped(json, false);
}
export function SetLifetimeMembersDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'emails': json['emails'],
        'lifetimeMember': json['lifetime_member'],
    };
}
export function SetLifetimeMembersDtoToJSON(json) {
    return SetLifetimeMembersDtoToJSONTyped(json, false);
}
export function SetLifetimeMembersDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'emails': value['emails'],
        'lifetime_member': value['lifetimeMember'],
    };
}
